import { PATHS } from 'routes/routes.constants';

import { generateOTCallbackSearchParams } from 'screens/OTLogin/utils';
import { NAMESPACES, REGION_REDIRECT_MAP } from './constants';
import type { Namespace, Region } from './types';

const getNamespace = (): Namespace => {
  const namespace = process.env.NEXT_PUBLIC_POLYAI_ENVIRONMENT as Namespace;

  if (!NAMESPACES.includes(namespace)) {
    console.warn(
      `Unknown namespace environment: ${namespace}. Defaulting to 'production'.`,
    );
    return 'production';
  }

  return namespace;
};

const constructLoginUrl = (redirectURL: string) => {
  return `${redirectURL}${PATHS.CALLBACK}?${generateOTCallbackSearchParams()}`;
};

const constructCreateIntegrationUrl = (
  redirectURL: string,
  selectedRegion: Region,
) => {
  const existingParams = new URLSearchParams(window.location.search);
  existingParams.set(
    'region',
    selectedRegion.toLowerCase().replaceAll(' ', '-'),
  );

  return `${redirectURL}${PATHS.OPENTABLE_LOGIN}?${existingParams.toString()}`;
};

export const getRedirectURL = (
  selectedRegion: Region,
  isNewIntegration: boolean,
) => {
  const namespace = getNamespace();
  const baseRedirectURL = REGION_REDIRECT_MAP[namespace][selectedRegion];

  return isNewIntegration
    ? constructCreateIntegrationUrl(baseRedirectURL, selectedRegion)
    : constructLoginUrl(baseRedirectURL);
};
